import { BarChart3, Building2, ClipboardList, FolderKanban, History, LayoutDashboard, MapPinned, Receipt, Settings, TableProperties, Users } from "lucide-react";
import { NavLink } from "react-router-dom";
import { InstallAppButton } from "../common/InstallAppButton";
import { LumenBrand } from "../common/LumenBrand";

const navigationItems = [
  { label: "Dashboard", path: "/dashboard", icon: LayoutDashboard, permission: "dashboard" },
  { label: "Customers", path: "/customers", icon: Building2, permission: "customers" },
  { label: "Records", path: "/records", icon: FolderKanban, permission: "records" },
  { label: "Loads", path: "/loads", icon: ClipboardList, permission: "loads" },
  { label: "Dispatch Board", path: "/dispatch-board", icon: TableProperties, permission: "dispatch_board" },
  { label: "Planning Board", path: "/planning-board", icon: MapPinned, permission: "planning_board" },
  { label: "Invoices", path: "/invoices", icon: Receipt, permission: "invoices" },
  { label: "Audit Trail", path: "/audit-trail", icon: History, requireAdmin: true },
  { label: "Reports", path: "/reports", icon: BarChart3, permission: "reports" },
  { label: "Users", path: "/users", icon: Users, requireAdmin: true },
  { label: "Settings", path: "/settings", icon: Settings, permission: "settings" },
];

export const Sidebar = ({ user }) => (
  <aside className="w-full border-b border-zinc-200 bg-zinc-50/90 px-4 py-4 backdrop-blur md:fixed md:left-0 md:top-0 md:h-screen md:w-64 md:border-b-0 md:border-r md:px-5 md:py-6">
    <div className="panel-surface flex h-full flex-col gap-5 px-4 py-5 md:px-5 md:py-6">
      <div data-testid="sidebar-brand-block">
        <LumenBrand compact testId="sidebar-brand" />
      </div>

      <nav className="flex gap-2 overflow-x-auto md:flex-1 md:flex-col md:overflow-visible" data-testid="sidebar-navigation">
        {navigationItems.filter((item) => (item.requireAdmin ? user?.role === "Admin" : !item.permission || user?.permissions?.includes(item.permission))).map(({ label, path, icon: Icon }) => (
          <NavLink
            key={path}
            to={path}
            className={({ isActive }) => `sidebar-link min-w-max md:min-w-0 ${isActive ? "sidebar-link-active" : ""}`}
            data-testid={`sidebar-link-${label.toLowerCase()}`}
          >
            <Icon className="h-4 w-4 shrink-0" />
            <span className="text-sm font-medium">{label}</span>
          </NavLink>
        ))}
      </nav>

      <div className="hidden md:block" data-testid="sidebar-install-block">
        <InstallAppButton compact testId="sidebar-install-app-button" />
      </div>
    </div>
  </aside>
);